import { Instance } from 'mobx-state-tree';
import { SkippedShopifyOrderDtoModelBase } from './SkippedShopifyOrderDtoModel.base';

/* The TypeScript type of an instance of SkippedShopifyOrderDtoModel */
export interface SkippedShopifyOrderDtoModelType extends Instance<typeof SkippedShopifyOrderDtoModel.Type> {}

/* A graphql query fragment builders for SkippedShopifyOrderDtoModel */
export { selectFromSkippedShopifyOrderDto, skippedShopifyOrderDtoModelPrimitives, SkippedShopifyOrderDtoModelSelector } from './SkippedShopifyOrderDtoModel.base';

/**
 * SkippedShopifyOrderDtoModel
 */
export const SkippedShopifyOrderDtoModel = SkippedShopifyOrderDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
